/**
 * Тема зала для фильмов Человека-паука: выбранные и занятые места
 * рисуются маской, а не обычными квадратами.
 */
export function isSpiderManFilm(name?: string | null): boolean {
    if (!name) return false

    const normalized = name
        .toLowerCase()
        .replace(/ё/g, "е")
        .replace(/[\s\-–—._:·]+/g, "")

    return normalized.includes("человекпаук") || normalized.includes("spiderman")
}
